<template>
  <div>
    <b-button-group>
      <b-button
        :disabled="relatie == null || state == 'loading'"
        variant="success"
        @click="openModal()"
      >
        <i class="icon-magic-wand" /> Factuurregels op basis van units
        <i 
          v-if="state == 'loading'" 
          class="fa fa-spinner" 
          rotate
        />
      </b-button>
      <slot />
    </b-button-group>

    <b-modal
      v-model="showModal"
      title="Kies units"
      class="modal-success"
      size="xl"
      ok-variant="success"
      @ok="wizard = false"
    >
      <template 
        v-if="relatie" 
        slot="modal-title"
      >
        {{ units.length }} units van {{ relatie.Naam }}
        <b-button
          :disabled="state == 'loading'"
          variant="primary"
          size="sm"
          class="mx-1"
          @click="getUnits()"
        >
          <b-spinner 
            v-if="state == 'loading'" 
            small
          /> {{ state == 'loading' ? 'Laden...' : 'Opnieuw ophalen' }}
        </b-button>
      </template>

      <v-client-table
        id="dataTable"
        :columns="columns"
        :data="units"
        :options="options"
        theme="bootstrap4"
        busy="true"
      >
        <input
          slot="Selecteren"
          v-model="selectedUnits"
          slot-scope="props"
          :value="props.row.Id"
          type="checkbox"
        >
        <div slot="empty">
          Geen resultaat
        </div>
        <div slot="busy">
          Laden...
        </div>
        <div
          slot="child_row"
          slot-scope="props"
        >
          {{ props.row.Keuringsnummer }} bij {{ props.row.Keuringsinstantie }}
        </div>
      </v-client-table>

      <template slot="modal-footer">
        <b-input 
          v-model="extraOmschrijving" 
          type="text" 
          placeholder="Extra omschrijving"
        />
        <b-input 
          v-model="bedrag" 
          type="text"
        />
        <b-button
          :disabled="geselecteerdUnits.length == 0"
          variant="primary"
          @click="createFactuurregels()"
        >
          Aanmaken {{ geselecteerdUnits.length }} factuurmomenten
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";

Vue.use(ClientTable);

export default {
  name: "UnitModal",
  components: {
    ClientTable,
    Event
  },
  mixins: [],
  props: ["relatie", "regels"],
  data() {
    return {
      units: [],
      extraOmschrijving: "",
      bedrag: 0,
      state: "idle",
      showModal: false,
      columns: ["Selecteren", "UnitKenmerk", "Titel", "Adres", "WijkPlaats"],
      options: {
        headings: {
          UnitKenmerk: "Unitnummer",
          Titel: "Titel",
          Adres: "Adres + huisnummer",
          WijkPlaats: "Plaats"
        },
        sortable: ["UnitKenmerk", "Titel", "WijkPlaats"],
        filterable: ["UnitKenmerk", "Titel", "Adres", "WijkPlaats"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      selectedUnits: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default"
    };
  },
  computed: {
    geselecteerdUnits: function() {
      var u = [];
      this.selectedUnits.forEach(elem => {
        this.units.find(obj => {
          if (obj.Id === elem) {
            u.push(obj);
          }
        });
      });
      return u;
    }
  },
  watch: {
    state: function(v) {
      console.log("state is changed to ...", v);
    }
  },
  mounted() {},
  methods: {
    markAll() {},
    createFactuurregels() {
      console.log("Factuurregels moeten worden aangemaakt.");
      var vm = this;
      this.geselecteerdUnits.forEach(u => {
        var regel = {
          Aantal: 1,
          Omschrijving: u.UnitKenmerk,
          Bedrag: this.bedrag,
          ExtraOmschrijving: this.extraOmschrijving,
          Unit: u
        };
        console.log(regel);
        this.regels.push(regel);
      });
      vm.showModal = false;
    },
    openModal: function() {
      //console.log();
      this.showModal = true;
      if (this.units.length == 0) this.getUnits();
    },
    getUnits: function() {
      var vm = this;
      this.state = "loading";
      this.$http
        .get("/relaties/" + this.relatie.Id + "/units")
        .then(function(response) {
          //console.log(response);
          console.log(response.data);
          vm.units = response.data.units;
          vm.state = "loaded";
        })
        .catch(function(error) {
          console.log(error);
          vm.state = "error";
        })
        .then(function() {
          //always executed
          vm.state = "idle";
        });
    }
  },
};
</script>

<style lang="scss">
#dataTable {
  width: 95%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
